import { render, staticRenderFns } from "./TicketLogsView.vue?vue&type=template&id=2269d07b&scoped=true&"
import script from "./TicketLogsView.vue?vue&type=script&lang=js&"
export * from "./TicketLogsView.vue?vue&type=script&lang=js&"
import style0 from "./TicketLogsView.vue?vue&type=style&index=0&id=2269d07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269d07b",
  null
  
)

export default component.exports